import { Copyright } from '@c/Content/Copyright'
import { UserAgreement } from '@c/Content/UserAgreement'
import { faMagnifyingGlass, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cns from 'classnames'
import { RefObject, useEffect, useMemo, useRef, useState } from 'react'
import ReactGA from 'react-ga4'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import CategoryFilter from '@/components/Catalog/CategoryFilter'
import { InterestPoint } from '@/core/interface'
import { useAppDispatch } from '@/core/store'
import { useAppSelector } from '@/core/store'
import { setGotTutorial } from '@/core/store/catalog.store'
import { setSelectedInterestPoint } from '@/core/store/catalog.store'
import { setModal } from '@/core/store/ui.store'

import { IconDefaultPoint, IconMenu, IconSearch, IconSearchInput, IconUser } from '../Ui/Icons'

//TODO fix it!!!!!!!!!!
const icon_types = new Map([
  ['museum', '/img/new/muse.png'],
  ['building', '/img/new/arch.png'],
  ['church', '/img/new/chur.png'],
  ['plaza', '/img/new/plac.png'],
  ['street', '/img/new/plac.png'],
  ['bridge', '/img/new/bidg.png'],
  ['B-P', '/img/new/plac.png'],
  ['B-M', '/img/new/muse.png'],
  ['Area', '/img/new/plac.png'],
  ['monument', '/img/new/scul.png'],
  ['B', '/img/new/arch.png'],
  ['O', '/img/new/star.png'],
  ['other', '/img/new/star.png'],
  ['T', '/img/new/star.png'],
  ['CAFE', '/img/new/cafe.png'],
  ['ICE-CR', '/img/new/ice-cream.png'],
  ['REST', '/img/new/restaurant.png'],
  ['BAR', '/img/new/restaurant.png'],
  ['TERR', '/img/new/terrace.png'],
])

const Header = () => {
  const { t } = useTranslation('header')
  const dispatch = useAppDispatch()

  const [menuShown, setMenuShown] = useState(false)
  const [navMenuOpen, setMenuOpen] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  const [searchResult, setSearchResult] = useState<InterestPoint[]>([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [agreement, setAgreement] = useState(false)
  const [copyright, setCopyright] = useState(false)
  const [authenticatedUsed, setAuthenticatedUsed] = useState(false)

  const filterModalRef: RefObject<HTMLDivElement> = useRef(null)
  const navMenuRef: RefObject<HTMLDivElement> = useRef(null)
  const searchResultRef: RefObject<HTMLDivElement> = useRef(null)
  const searchBarRef: RefObject<HTMLInputElement> = useRef(null)

  const { isFilterChanged, interestPoints, selectedInterestPoint , gotTutorial, isPayedClient  } = useAppSelector(
    (store) => store.catalogStore,
  )

  const pages = useMemo(() => {
    return [{ slug: '#', modal: 'feedback', label: 'nav3' }]
  }, [])
  const url = window.location.pathname.split('/').pop()

  function getCookie(name) {
    const cookies = document.cookie.split('; ')
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=')
      if (cookieName === name) {
        return decodeURIComponent(cookieValue)
      }
    }
    return null
  }

  useEffect(() => {
    const refresh_token = getCookie('WM_RefreshToken')
    const user_id = getCookie('WM_ID')
    // console.log(refresh_token, access_token)
    if (refresh_token && user_id) {
      setAuthenticatedUsed(true)
    }
    console.log(url)
    // if (url == 'map') setFilterOpen(true)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      // console.log(event)
      if (
        filterOpen &&
        filterModalRef.current &&
        !filterModalRef.current.contains(event.target as Node)
      ) {
        setFilterOpen(false)
      }

      if (navMenuOpen && navMenuRef.current && !navMenuRef.current.contains(event.target as Node)) {
        setMenuOpen(false)
      }

      // if (
      //   (searchOpen &&
      //     searchResultRef.current &&
      //     !searchResultRef.current.contains(event.target as Node)) ||
      //   (searchBarRef.current && !searchBarRef.current.contains(event.target as Node))
      // ) {
      //   setSearchOpen(false)
      // }
    }

    document.addEventListener('touchstart', handleClickOutside)
    return () => {
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [filterOpen, navMenuOpen])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterOpen &&
        filterModalRef.current &&
        !filterModalRef.current.contains(event.target as Node)
      ) {
        setFilterOpen(false)
      }

      if (navMenuOpen && navMenuRef.current && !navMenuRef.current.contains(event.target as Node)) {
        setMenuOpen(false)
      }

      // if (
      //   (searchOpen &&
      //     searchResultRef.current &&
      //     !searchResultRef.current.contains(event.target as Node)) ||
      //   (searchBarRef.current && !searchBarRef.current.contains(event.target as Node))
      // ) {
      //   setSearchOpen(false)
      // }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [filterOpen, navMenuOpen])

  const toggleFilterModal = (event: React.MouseEvent) => {
    event.stopPropagation()
    setFilterOpen((prevState) => !prevState)
    setMenuOpen(false) // Close the nav menu if it's open
    setSearchOpen(false)
    ReactGA.event({
      category: 'click',
      action: filterOpen ? 'FilterMenuClose' : 'FilterMenuOpen',
      label: filterOpen ? 'close_filter' : 'open_filter',
    })
  }

  const toggleSearchFilter = (event: React.MouseEvent) => {
    event.stopPropagation()
    setSearchOpen((prevState) => !prevState)
    setMenuOpen(false) // Close the nav menu if it's open
    setFilterOpen(false) // Close the nav menu if it's open
    setSearchResult([])
    setSearchValue('')
    // ReactGA.event({
    //   category: 'click',
    //   action: filterOpen ? 'FilterMenuClose' : 'FilterMenuOpen',
    //   label: filterOpen ? 'close_filter' : 'open_filter',
    // })
  }

  const toggleNavMenu = (event: React.MouseEvent) => {
    event.stopPropagation()
    setMenuOpen((prevState) => !prevState)
    setFilterOpen(false) // Close the filter modal if it's open
    setSearchOpen(false)
    ReactGA.event({
      category: 'click',
      action: navMenuOpen ? 'MenuClose' : 'MenuOpen',
      label: navMenuOpen ? 'close_menu' : 'open_menu',
    })
  }

  const handleFilterApply = () => {
    setFilterOpen(false)
  }

  const handleSearchBar = (event) => {
    // console.log(event)
    // console.log(event.target.value)
    setSearchValue(event.target.value)
    if (!event.target.value) {
      setSearchResult([])
      return
    }
    // console.log(interestPoints)
    const interestPointsFiltered = interestPoints.filter((point) => {
      return point.title.toLowerCase().includes(event.target.value.toLowerCase())
    })
    setSearchResult(interestPointsFiltered)
  }

  const getCategoryIcon = (cat: string, id: string) => {
    //TODO: i18n
    // if (id == 'sr2ykk5kyt') {
    //   console.log(cat)
    // }
    const n = icon_types.get(cat)
    return n
  }

  // console.log(useLocation().pathname)
  setTimeout(() => {
    dispatch(setGotTutorial(true))
    if (!gotTutorial) dispatch(setModal({ name: 'tutorial-prompt' }))
  }, 3000)

  return (
    <>
      <UserAgreement active={agreement} onClose={() => setAgreement(false)} />
      <Copyright active={copyright} onClose={() => setCopyright(false)} />
      <nav className={'header'}>
        {/* <div className="wm-header-menu">
          <div className="wm-navigation"> */}
        <div className="wm-logo">
          <div className="wm-logo-icon">
            <a href={process.env.REACT_APP_WP_URL as string}>
              <img src="WM-icon-light-green-small.png" width="32" height="32"></img>
            </a>
          </div>

          <div className="wm-logo-name">
            <Link to={process.env.REACT_APP_WP_URL as string}>
              <span>
                <span className="wm-logo-name-light">World</span>Museum
              </span>
            </Link>
          </div>
        </div>
        <div className="header__nav">
          <button className="burger_btn search-bar-button" onClick={toggleSearchFilter}>
            {/* <FontAwesomeIcon icon={faMagnifyingGlass} className="fa-xl" /> */}
            <IconSearch active={searchOpen}></IconSearch>
          </button>
          {useLocation().pathname == '/map' && (
            <button onClick={toggleFilterModal} className="burger_btn">
              {/* <img className="filter__img" src="/img/new/base.png" alt="Base icon" /> */}
              <IconDefaultPoint></IconDefaultPoint>
              {/* <svg
                id={'noClose'}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
              >
                <path
                  id={'noClose'}
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11 8C9.13616 8 7.57006 6.72523 7.12602 5H0V3H7.12602C7.57006 1.27477 9.13616 0 11 0C13.2091 0 15 1.79086 15 4C15 6.20914 13.2091 8 11 8ZM17 3H20V5H17V3ZM6 18C4.13616 18 2.57006 16.7252 2.12602 15H0V13H2.12602C2.57006 11.2748 4.13616 10 6 10C8.20914 10 10 11.7909 10 14C10 16.2091 8.20914 18 6 18ZM12 15H20V13H12V15ZM8 14C8 15.1046 7.10457 16 6 16C4.89543 16 4 15.1046 4 14C4 12.8954 4.89543 12 6 12C7.10457 12 8 12.8954 8 14ZM13 4C13 5.10457 12.1046 6 11 6C9.89543 6 9 5.10457 9 4C9 2.89543 9.89543 2 11 2C12.1046 2 13 2.89543 13 4Z"
                  fill={isFilterChanged ? '#FF0000' : filterOpen ? '#FD8108' : '#2B3537'}
                />
              </svg> */}
            </button>
          )}
          <a
            className="burger_btn search-bar-button"
            href={`${process.env.REACT_APP_WP_URL}/my-account/`}
          >
            {/* <FontAwesomeIcon icon={faUser} className="fa-xl" /> */}
            <IconUser active={authenticatedUsed}></IconUser>
          </a>
          <button onClick={toggleNavMenu} className="burger_btn">
            <IconMenu active={navMenuOpen}></IconMenu>
            {/* <svg
              id={'noClose'}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <rect
                id={'noClose'}
                x="2"
                y="5"
                width="20"
                height="2"
                fill={navMenuOpen ? '#66CFC3' : '#fff'}
              />
              <rect
                id={'noClose'}
                x="2"
                y="11"
                width="20"
                height="2"
                fill={navMenuOpen ? '#66CFC3' : '#fff'}
              />
              <rect
                id={'noClose'}
                x="2"
                y="17"
                width="20"
                height="2"
                fill={navMenuOpen ? '#66CFC3' : '#fff'}
              />
            </svg> */}
          </button>

          {searchOpen && (
            <>
              <div className="search-container">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Type to search..."
                  onChange={handleSearchBar}
                  ref={searchBarRef}
                />
                <IconSearchInput className="search-icon"></IconSearchInput>
              </div>

              {searchResult && searchResult.length > 0 && (
                <div ref={searchResultRef} className="search-results">
                  {searchResult.map(function (point, i) {
                    return (
                      <div
                        key={i}
                        className="search-result"
                        onClick={() => {
                          dispatch(setSelectedInterestPoint(point))
                          // dispatch(setSelectedInterestPoint(null))
                        }}
                      >
                        <span className="search-result-icon">
                          <img
                            src={
                              getCategoryIcon(point.type, point.id) || '/img/new/base.png'
                            }
                            alt="point icon"
                          />
                        </span>
                        <span className="search-result-name">{point.title}</span>
                      </div>
                    )
                  })}
                </div>
              )}
              {searchValue != '' && searchResult.length == 0 && (
                <div className="search-results">
                  <p>Sorry, nothing found</p>
                </div>
              )}
            </>
          )}

          {filterOpen && (
            <>
              <div ref={filterModalRef} className={'filter_modal'}>
                <CategoryFilter onApply={handleFilterApply} />
              </div>
              {/* <div className="filter_description">
                <div className="filter_description_content">
                  <p>
                    <strong>On the map you can:</strong>
                  </p>
                  <p>
                    <strong>Discover nearby:</strong> See on the map the most fascinating landmarks
                    located right near you. Whether you are seeking iconic monuments or hidden gems,
                    exploring must see places in Rome becomes effortless with our service.
                  </p>
                  <p>
                    <strong>Dive into history:</strong> Enjoy captivating stories about any of the
                    450 carefully selected sites, described in detail by AI and our experts. Embark
                    on a Rome walking tour and immerse yourself in the culture and history that
                    define this eternal city.
                  </p>
                </div>
              </div> */}
            </>
          )}

          {navMenuOpen && (
            <div ref={navMenuRef} className={'nav__menu'}>
              <Link
                to={process.env.REACT_APP_WP_URL as string}
                onClick={() => {
                  setMenuOpen(false)
                  ReactGA.event({
                    category: 'click',
                    action: 'WA_MenuClick',
                    label: 'go_to_homepage',
                  })
                }}
              >
                Home page
              </Link>
              <Link
                onClick={() => {
                  dispatch(setModal({ name: 'feedback' }))
                  setMenuOpen(false)
                  ReactGA.event({
                    category: 'click',
                    action: 'WA_MenuClick',
                    label: 'open_feedback',
                  })
                }}
                to="#feedback"
              >
                Feedback
              </Link>
              <Link
                onClick={() => {
                  dispatch(setModal({ name: 'tutorial-prompt' }))
                  setMenuOpen(false)
                  ReactGA.event({
                    category: 'click',
                    action: 'WA_MenuClick',
                    label: 'open_tutorial',
                  })
                }}
                to="#tutorial"
              >
                Tutorial
              </Link>
              {/* <Link
                onClick={() => {
                  setAgreement(true)
                  setMenuOpen(false)
                  ReactGA.event({
                    category: 'click',
                    action: 'MenuClick',
                    label: 'open_user_agreement',
                  })
                }}
                to="#user-agreement"
              >
                User agreement
              </Link> */}
              {/* <Link
                onClick={() => {
                  setCopyright(true)
                  setMenuOpen(false)
                  ReactGA.event({
                    category: 'click',
                    action: 'MenuClick',
                    label: 'open_copyright',
                  })
                }}
                to={'/map'}
              >
                Copyright
              </Link> */}
            </div>
          )}
        </div>
        {/* </div>
        </div> */}
      </nav>

      <ul className={cns('sidenav', menuShown && '_active')} id="sidenav">
        {pages.map((page, idx) => (
          <li key={idx} onClick={() => setMenuShown(false)}>
            {page.modal ? (
              <a href={page.slug} onClick={() => dispatch(setModal({ name: page.modal }))}>
                {t(page.label)}
              </a>
            ) : (
              <Link to={page.slug}>{t(page.label)}</Link>
            )}
          </li>
        ))}
      </ul>

      <div
        className={cns('sidenav-overlay', menuShown && '_active')}
        onClick={() => setMenuShown(false)}
      />
    </>
  )
}

export default Header
